/** Fallback country thumbnails when the current slug is not in the  popular cities list. */
export const CA_CITY_FALLBACK_IMG = '/next/assets/images/local-focus/countries/Canada.jpg';
export const US_CITY_FALLBACK_IMG = '/next/assets/images/local-focus/countries/USA.jpg';
